import { createEventsFromSchematics, eventDetail } from "@kells/apis/analytics";

export const HALEON_GA_ID = "G-Y4SDGB16F5";

interface HaleonClickProductLinkDetail {
  product: string;
}

const eventCreators = createEventsFromSchematics({
  HaleonGetStarted: {
    displayedName: "haleon get started",
  },
  HaleonStartCapture: {
    displayedName: "haleon start capturing",
  },
  HaleonCaptureLeftPhoto: {
    displayedName: "haleon capture left photo",
  },
  HaleonCaptureRightPhoto: {
    displayedName: "haleon capture right photo",
  },
  HaleonCaptureFrontPhoto: {
    displayedName: "haleon capture front photo",
  },
  HaleonSubmitPhotos: {
    displayedName: "haleon submit photos",
  },
  HaleonClickProductLink: {
    displayedName: "haleon click product link",
    detail: eventDetail<HaleonClickProductLinkDetail>(),
  },
});

export const {
  HaleonCaptureLeftPhoto,
  HaleonCaptureRightPhoto,
  HaleonCaptureFrontPhoto,
  HaleonSubmitPhotos,
  HaleonClickProductLink,
  HaleonGetStarted,
  HaleonStartCapture,
} = eventCreators;
